import { AuthUser } from '@core/domain/model/user/auth-user.model';
import { AuthUserApi } from '@core/api/model/user/auth-user-api.model';

export class AuthUserMapper {
  /** Transform user from api */
  public static userFromApi(userApi: AuthUserApi): AuthUser {
    return {
      ...userApi,
      crmCode: userApi.codigoCRM,
      type: userApi.tipoCliente,
      phone: userApi.telefono,
      superUser: userApi.superusuario,
      invoiceNotice: userApi.avisoDisponibilidad,
      dataProtection: userApi.proteccionDatos,
      communicationLanguage: userApi.idiomaComunicacion,
      informationRehabilitation: userApi.informacionRehabilitacionEnergetica,
      informationCommercializer: userApi.informacionComercializadora,
    };
  }
}
